import { ApolloCache, FetchResult } from "@apollo/client";
import {
	SharingRecord,
	SharingRecordCreateInput,
	SharingRecordCreateMutation,
	SharingRecordDeleteMutation,
	SharingRecordUpdateInput,
	SharingRecordUpdateMutation,
} from "../../../Utilities";
import * as SharingRecordFormValues from "./form-values";

export function customUpdateCacheForCreate(
	_input: SharingRecordCreateInput,
	_cache: ApolloCache<any>,
	_result: Omit<FetchResult<SharingRecordCreateMutation, Record<string, any>, Record<string, any>>, "context">,
) {}

export function customUpdateCacheForUpdate<
	K extends keyof SharingRecordFormValues.Detail = keyof SharingRecordFormValues.Detail,
>(
	_input: SharingRecordUpdateInput,
	_initialFormValues: SharingRecordFormValues.DetailSubset<K>,
	cache: ApolloCache<any>,
	_result: Omit<FetchResult<SharingRecordUpdateMutation, Record<string, any>, Record<string, any>>, "context">,
) {
	// to refresh the users list for the sharing record view element
	cache.evict({ id: "ROOT_QUERY", fieldName: "userConnection" });
}

export function customUpdateCacheForDelete(
	_id: SharingRecord["id"],
	_cache: ApolloCache<any>,
	_result: Omit<FetchResult<SharingRecordDeleteMutation, Record<string, any>, Record<string, any>>, "context">,
) {}
